export function runAsync(block: () => Promise<void>): void {
  new Promise((resolve, reject) => {
    block()
      .then(_ => resolve(null))
      .catch(error => {
        console.log('runAsync exception', error);
        reject();
      });
  });
}
